export default __webpack_public_path__ + "static/media/bio-image-01.32871525.png";